import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

import { getAllErrors, getAllNotices } from '../../selectors';
import { clearError, clearNotice, handleError } from '../../actions';
import './ErrorContainer.scss';

import { ReactComponent as ExclamationIcon } from '../../assets/icons/icons8-info.svg';
import { ReactComponent as IconClose } from '../../assets/icons/closeNew.svg';
import { ReactComponent as InfoIcon } from '../../assets/icons/info.svg';

interface IErrorContainer {
  errors?: { [key: string]: any };
  notices?: { [key: string]: any };
  getDataFromRedux?: boolean;
  journeyType?: string;
  classNameErrorContainer?: string;
  classNameNoticeContainer?: string;
  classNameErrorWrapper?: string;
}

type Props = IErrorContainer;

const ErrorContainer: FC<Props> = ({
  errors = {},
  notices = {},
  getDataFromRedux = true,
  journeyType = 'journey1',
  classNameErrorContainer = '',
  classNameNoticeContainer = '',
  classNameErrorWrapper = '',
}) => {
  const dispatch = useDispatch();
  const errorsState = useSelector(getAllErrors);
  const noticesState = useSelector(getAllNotices);
  const errorsList = Object.values(getDataFromRedux ? errorsState : errors);
  const noticesList = Object.values(getDataFromRedux ? noticesState : notices);

  const returnLeftPart = (message: any, action: any, submessage?: any) => (
    <>
      <p>
        {message}
        {submessage && <span>{submessage}</span>}
      </p>
      {getDataFromRedux && (
        <div
          className={'pointer closeErrorIcon'}
          onClick={(e) => {
            e.stopPropagation();
            dispatch(action);
          }}
        >
          <IconClose />
        </div>
      )}
    </>
  );

  return (
    <div
      className={classNames(
        'errorContainerWrapper',
        {
          afterSales: journeyType === 'dashboard',
          nonBE: !getDataFromRedux,
        },
        classNameErrorWrapper,
      )}
    >
      {errorsList.length > 0 &&
        errorsList.map((error: any) => {
          const { code, message, submessage } = error;
          return (
            <div
              key={`error-container-${message}`}
              className={classNames('errorContainer pointer', classNameErrorContainer)}
              onClick={() => handleError(code, error.class, journeyType === 'journey2' || journeyType === 'journey02')}
            >
              <ExclamationIcon />
              {returnLeftPart(message, clearError({ code: code, class: error.class }), submessage)}
            </div>
          );
        })}

      {noticesList.length > 0 &&
        noticesList.map(({ message, code, urn }) => (
          <div
            key={`notice-container-${urn}`}
            className={classNames('errorContainer notices', classNameNoticeContainer)}
          >
            <InfoIcon className='notice' />
            {returnLeftPart(message, clearNotice({ code, urn }))}
          </div>
        ))}
    </div>
  );
};

export default ErrorContainer;
